import { render, staticRenderFns } from "./AddBlacklistItem.vue?vue&type=template&id=c7bda110&scoped=true&"
import script from "./AddBlacklistItem.vue?vue&type=script&lang=js&"
export * from "./AddBlacklistItem.vue?vue&type=script&lang=js&"
import style0 from "./AddBlacklistItem.vue?vue&type=style&index=0&id=c7bda110&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7bda110",
  null
  
)

export default component.exports